"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.versionDocs = void 0;
var versionDocs = exports.versionDocs = {
  name: 'version',
  category: 'Constants',
  syntax: ['version'],
  description: 'A string with the version number of math.js',
  examples: ['version'],
  seealso: []
};